import React, { useMemo } from "react";

import Row from "antd/es/row";
import { useIntl } from "react-intl";

import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";
import { EntityTypeSupportingReports } from "@mapmycustomers/shared/types/entity";
import { isDefined } from "@mapmycustomers/shared/util/assert";
import { Alert } from "@mapmycustomers/ui";

import useView from "@app/component/view/utils/useView";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";

import styles from "./Common.module.scss";

interface Props {
  entityType: EntityTypeSupportingReports;
}

const DateTimeWarning: React.FC<Props> = ({ entityType }) => {
  const intl = useIntl();
  const fieldModel = getFieldModelByEntityType(entityType);
  const {
    viewState: { filter },
  } = useView();
  const showWarning = useMemo(() => {
    return Object.keys(filter)
      .map((fieldName) => fieldModel.getByName(fieldName))
      .filter(isDefined)
      .some((field) => [FieldType.DATE, FieldType.DATE_TIME].includes(field.filterType));
  }, [filter, fieldModel]);

  return showWarning ? (
    <section>
      <Row>
        <Alert
          className={styles.warning}
          message={intl.formatMessage(
            {
              id: "reports.exports.create.edit.alert1",
              defaultMessage:
                "<strong>Date or time filter applied.</strong> Please note that if you have set up this data for repeating exports, filter rules for date or time may prevent accurate data from being sent in the future.",
              description: "",
            },
            {
              strong: (text: string) => <strong>{text}</strong>,
            }
          )}
          showIcon
          type="warning"
        />
      </Row>
    </section>
  ) : null;
};

export default DateTimeWarning;
